// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"4b02bef0","214":"9101120d","712":"194b13e3","771":"ae728be4","815":"feab6f86","940":"054e1534"}[chunkId] + ".chunk.js";
};